import { Typography, Switch } from '@mui/material';
import { Controller } from 'react-hook-form';
import useStyles from './styles';

const AccordionToggle = ({
  item,
  index,
  handleChangeSwitch,
  isViewPage,
  control,
  setValue,
}) => {
  const { classes } = useStyles();

  return (
    <div className={classes.flexGap}>
      <Typography className={classes.accordionToggleLabel}>
        Copy from Manager’s overview
      </Typography>
      <Controller
        name={`fundInformation[${index}][copyFund]`}
        defaultValue={item?.copyFund}
        control={control}
        render={({ field: { name, value } }) => (
          <Switch
            name={name}
            onChange={(event) => {
              const copyFund = !event.target.checked;
              if (copyFund) {
                setValue(`fundInformation[${index}][title]`, '');
                setValue(`fundInformation[${index}][shortDescription]`, '');
                setValue(`fundInformation[${index}][provideCommentary]`, false);
                setValue(`fundInformation[${index}][commentary]`, '');
              }
              setValue(`fundInformation[${index}][copyFund]`, copyFund);
              handleChangeSwitch(index, event.target.checked);
            }}
            checked={!value}
            disabled={isViewPage}
          />
        )}
      />
      <Typography className={classes.accordionToggleLabel}>
        Enter different commentary
      </Typography>
    </div>
  );
};

export default AccordionToggle;
